import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AlertType } from '../../../shared/models/alertType';
import { AccountService } from '../../../core/services/account.service';
import { showAlertDialog } from '../../../shared/helpers/showAlertDialog';
import { BRANDING } from '../../../core/constants/branding.constants';

@Component({
  selector: 'app-redefinir-senha',
  imports: [MatIconModule, ReactiveFormsModule, CommonModule],
  templateUrl: './redefinir-senha.component.html',
  styleUrl: './redefinir-senha.component.scss'
})
export class RedefinirSenhaComponent implements OnInit {
  branding = BRANDING;
  redefinirSenhaForm: FormGroup;
  passwordVisible: boolean = false;
  confirmationPasswordVisible: boolean = false;
  novaSenhaFocused: boolean = false;
  confirmeSenhaFocused: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private accountService: AccountService,
  ) {
    this.redefinirSenhaForm = this.fb.group({
      novaSenha: ['', {
        validators: [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*]).+$')
        ],
      }],
      confirmeSenha: ['', {
        validators: [Validators.required],
      }]
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) {
      this.router.navigate(['account/login']);
    } else {
      this.accountService.verifyToken(token).subscribe(res => {
        if (!res) {
          this.router.navigate(['account/login']);
        }
      });
    }
  }

  passwordMatchValidator(form: FormGroup) {
    const novaSenha = form.get('novaSenha');
    const confirmeSenha = form.get('confirmeSenha');
    if (novaSenha?.value !== confirmeSenha?.value) {
      confirmeSenha?.setErrors({ mismatch: true });
      return { mismatch: true };
    } else {
      confirmeSenha?.setErrors(null);
      return null;
    }
  }

  onSubmit() {
    if (this.redefinirSenhaForm.invalid) return;

    const token = this.route.snapshot.queryParamMap.get('token');
    if (!token) return;

    this.accountService.resetPassword(token, this.redefinirSenhaForm.value.confirmeSenha).subscribe({
      next: () => {
        this.handleDialog(AlertType.Success, 'Sucesso!', 'Sua senha foi redefinida com sucesso!');
      },
      error: () => {
        this.router.navigate(['account/login']);
      },
    });
  }

  private handleDialog(alertType: AlertType, title: string, message: string) {
    const dialogRef = showAlertDialog(this.dialog, alertType, title, message);
    dialogRef.afterClosed().subscribe(() => this.navigateToLogin());
  }

  navigateToLogin() {
    this.router.navigate(['account/login']);
  }
}
